import React from 'react'
import styles from './ReferralSection.module.css'

const ReferralSection = ({ userProfile, onGenerateLink }) => {
  const handleGenerateLink = async (event) => {
    if (!userProfile) return

    event.preventDefault()
    event.stopPropagation()

    if (onGenerateLink) {
      onGenerateLink()
    }
  }

  return (
    <div className={styles.referralContainer}>
      <div className={styles.referralHeader}>
        <div className={styles.iconContainer}>
          <img
            className={styles.dollarIcon}
            src="/assets/icons/currency-dollar.svg"
            alt="Currency Dollar"
            width="20"
            height="20"
          />
        </div>
        <h3 className={styles.referralTitle}>Refer & Earn</h3>
      </div>

      <p className={styles.referralDescription}>
        Invite your friends to join tiiny.host and offer a 50% discount. You earn 30% of their revenue, up to $50 per
        referral.
      </p>

      <button className={styles.generateLinkButton} onClick={handleGenerateLink}>
        Get invite link
      </button>
    </div>
  )
}

export default ReferralSection
